// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__xoeig","wrapper":"style__wrapper__7X51J"};